export default "__VITE_ASSET__ClhkJaVb__"